import styled, { css } from 'styled-components';

// props 필터링
const shouldForwardProp = prop =>
  !['variant', 'color', 'size', 'disabled', 'textAlign'].includes(prop);

export const TypographyStyled = styled.div.withConfig({ shouldForwardProp })`
  font-family: 'Pretendard', sans-serif;
  color: ${props => (props.color ? `var(--${props.color})` : 'var(--GrayScale-900)')};
  text-align: ${props => props.textAlign || 'left'};

  /* Title variants */
  ${props =>
    props.variant === 'titleH1' &&
    css`
      font-size: 48px;
      font-weight: 900;
      line-height: 72px;
    `}

  ${props =>
    props.variant === 'titleH2' &&
    css`
      font-size: 36px;
      font-weight: 900;
      line-height: 54px;
    `}

  ${props =>
    props.variant === 'titleH3' &&
    css`
      font-size: 30px;
      font-weight: 700;
      line-height: 48px;
    `}

  ${props =>
    props.variant === 'titleH4' &&
    css`
      font-size: 24px;
      font-weight: 700;
      line-height: 36px;
    `}

  ${props =>
    props.variant === 'titleH5' &&
    css`
      font-size: 20px;
      font-weight: 400;
    `}

  /* Subtitle variants */
  ${props =>
    props.variant === 'subtitleBold' &&
    css`
      font-size: 18px;
      font-weight: 700;
      line-height: 28px;
    `}

  ${props =>
    props.variant === 'subtitleMedium' &&
    css`
      font-size: 18px;
      font-weight: 500;
      line-height: 28px;
    `}

  /* Body variants */
  ${props =>
    props.variant === 'body1Bold' &&
    css`
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
    `}

  ${props =>
    props.variant === 'body1Medium' &&
    css`
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
    `}

  ${props =>
    props.variant === 'body2Bold' &&
    css`
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
    `}

  ${props =>
    props.variant === 'body2Medium' &&
    css`
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
    `}

  /* Caption variants */
  ${props =>
    props.variant === 'captionBold' &&
    css`
      font-size: 12px;
      font-weight: 700;
      line-height: 18px;
    `}

  ${props =>
    props.variant === 'captionMedium' &&
    css`
      font-size: 12px;
      font-weight: 500;
      line-height: 18px;
    `}

  /* Optional text decoration */
  ${props =>
    props.decoration === 'underline' &&
    css`
      text-decoration: underline;
    `}
`;
